module.exports = __webpack_public_path__ + "img/ico_move_disabled.f5afb5cb.svg";